<template>
  <main class="outerDiv" :style="configStyle">
    <div class="headerclass">
        <navheader @logout="logout"/>
    </div>
        

        <div :class="mainDivClass">
            <loginuser ref="loginuser" v-if="!loggedIn" />
            <div v-if="loggedIn">
                <openclose v-if="currentNav=='openclose'" @hide="currentNav=''"/>
                <productgroup v-if="currentNav=='productgroup'"/>
                <productadmin v-if="currentNav=='product'" ref="productadmin"/>
                <transactions v-if="currentNav=='transactions'" ref="transactions"/>
                <inventory v-if="currentNav=='inventory'" />
                <library v-if="currentNav=='library'"/>
                <vendor v-if="currentNav=='vendor'"/>
                <tableadmin v-if="currentNav=='tables'"/>
                <reservationadmin v-if="currentNav=='reservations'"/>
                <categoryadmin v-if="currentNav=='categories'"/>
                <filterattributes v-if="currentNav=='filterattributes'"/>
            </div>
        </div>

        <!-- <spfooter/>   -->
        
    </main>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import style from '../style.js'
import format from '../format.js'
import datamethods from '../services/datamethods.js'
import spfooter from './footer.vue'
import navheader from './navheader.vue'
import loginuser from './loginuser.vue'
import openclose from './openclose/openclose.vue'
import productgroup from './productgroup/productgroup.vue'
import productadmin from './product/productadmin.vue'
import transactions from './transactions/transactions.vue'
import inventory from './inventory/inventory.vue'
import library from './library/library.vue'
import inventoryservice from '../services/inventoryservice.js'
import vendor from './vendor/vendor.vue'
import tableadmin from './tables/tableadmin.vue'
import reservationadmin from './reservations/reservationadmin.vue'
import categoryadmin from './category/categoryadmin.vue'
import filterattributes from './category/filterattributes.vue'
export default {
    components:{
        spfooter,
        navheader,
        loginuser,
        openclose,
        productgroup,
        productadmin,
        transactions,
        inventory,
        library,
        vendor,
        tableadmin,
        reservationadmin,
        categoryadmin,
        filterattributes

    },
    mixins:[datamethods, format,style,inventoryservice],
    computed:{
        ...mapFields([
            'loggedIn',
            'currentNav',
            'username',
            'oldpassword',
            'loggedInUser.isAdmin',
            'logoOverride',
           'showHeader',
           'locationList',
           'locationList_Inventory',
           'reportImageBasePath'

        ]),
        mainDivClass(){
            if(this.isAdmin){return "mainDivAdmin"}
            else{return "mainDivFullWidth"}
        },
        
         inventoryUseInventoryLocationList(){
            if(window.INVENTORY_USE_INVENTORY_LOCATION_LIST==undefined){return false}
            else{return window.INVENTORY_USE_INVENTORY_LOCATION_LIST}
        },
    },
    methods:{
    
        logout(){
            // Guard: transactions ref only exists while that tab is open (was crashing elsewhere).
            if(this.$refs.transactions){this.$refs.transactions.resetfilter()}
            this.currentNav=''
        },
        receiveMessage(event){
            try{
                var msg =  JSON.parse(event.data)
            }
            catch(err){
                return
            }
            
            var action = msg.action
            if(action !=undefined){
            
               // console.log("PA Receive Msg: " + action)
                switch (action) {
                    case 'refresh':
                        this.currentNav=''
                        if(window.SHOW_INVENTORY_LEVEL_ALERT){ this.getInventoryBelowTarget(-1)}
                        break;
                    case 'appupdate':
                        location.reload(true);
                    default:
                        break;
                }
                
            }
        },
        async GetLocations(){
            
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'ecommerce/admin/locations')

            if(response.Successful){
                this.locationList=response.locationList
                if(this.inventoryUseInventoryLocationList){
                    //get a special one
                    this.GetLocations_Inventory()
                }else{
                    //use this list
                    this.locationList_Inventory=this.locationList
                }
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
         async GetLocations_Inventory(){

            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'ecommerce/admin/locations_inventory')

            if(response.Successful){
                this.locationList_Inventory=response.locationList
                
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
        async getreportImageBasePath(){
                //call api
                
                var response = await this.callAPI(null,'ecommerce/admin/reportimagepath')
                //handle response
                if(response.Successful){
                    
                    this.reportImageBasePath = window.VUE_CONFIG_ReportAPI + response.StringResponse
                    console.log('img' + this.reportImageBasePath)
                }else{
                    this.message = response.Message
                }
                this.pleaseWait=false;
            }, 
    },
    mounted(){
        //to receive msgs
        window.addEventListener('message', this.receiveMessage)

        // ECommerceAdmin is X-API-Key native — there is no POS user login on the
        // ecommerce PaymentAPI (securityloginuser lives on the POS API). Auto-authenticate
        // so the admin shell renders; the X-API-Key (set in repository.js) is the auth.
        if(window.ECOM_SKIP_LOGIN !== false){
            this.isAdmin = true
            this.loggedIn = true
        }

        this.currentNav=''
        let urlParams = new URLSearchParams(window.location.search)
        let tmp = urlParams.get('email')
        if(tmp!=null){
            this.username = tmp;
        }

        let tmp2 = urlParams.get('temp')
        if(tmp2!=null){
            this.oldpassword = tmp2;
            this.$nextTick(()=>{
            //this.changepass()
            this.$refs.loginuser.changepassword();
            });
        }

    
        let tmp4 = urlParams.get('config')
        if(tmp4!=null){this.configOverride=tmp4 }

        

        console.log("inmount")
        // Removed the onbeforeunload guard: forms now use @submit.prevent, so it only
        // annoyed on legitimate refresh/close/back navigation.

        tmp = urlParams.get('header')
        if(tmp!=null){this.showHeader=tmp=='true'; }

        tmp = urlParams.get('token')
        if(tmp!=null){
            console.log('sso!')
            this.$refs.loginuser.post_login(tmp)
         }
         this.setColors();
         this.GetLocations();
         if(window.SHOW_INVENTORY_LEVEL_ALERT){
            this.getInventoryBelowTarget(-1)
         }
         

         var override =''
            if(override=='' && window.CONFIG_OVERRIDE!=undefined){
                override = window.CONFIG_OVERRIDE
            }

            this.AddConfigToAPI(override);
            
        this.getreportImageBasePath()
        document.title = 'Ecommerce Admin'
    }
}
</script>

<style lang="scss">
@import "@/assets/stylebase.scss";





body{
  height:95vh; 
  height: -webkit-fill-available;
  width:100vw;
  padding:0px;
  margin:0px;
  font-size:medium;
  color:var(--text-color);
}
.outerDiv{
  margin:0px;
  padding:0px;
    height:95vh;
    display:grid;
    /* header sizes to its content; content row fills the rest. Was `auto auto`, which on a
       fixed-height grid stretched the header row to ~half the viewport, leaving a large white
       gap between the nav and the tab content. */
    grid-template-rows:auto 1fr;
    grid-template-areas:
        "header header header"
        "center center center";
}
.mainDivFullWidth{

    grid-row:2;
    grid-column-start:1;
    grid-column-end: span 3;
    background-color:var(--background-color);
    padding:20px;
    height:96%;
}
.mainDivAdmin{
    grid-row:2;
    grid-column-start:1;
    grid-column-end: span 3;
    background-color:var(--background-color);
    padding:20px;
     height:96%;
}

.bordered{
    background-color: var(--frame-color);
    border-radius:5px;
    margin:10px 0px 10px 0px;
    padding:20px;
}


.horizFlex{
  display:flex;
  flex-direction: row;
  margin:0px;
}
.vertFlex{
  display:flex;
  flex-direction: column;
  margin:0px;
  
}
/* .horizFlexStretch{
  display:flex;
  padding:0px;
  flex-direction: row;
  margin:0px 0px 0px 10px ;
  justify-content:space-between;
} */
.rightjustified{
    text-align: right;
}
.leftjustified{
    text-align: left;
}
.subtitle{
    font-size:large;
    margin:20px;
}
.subtitleBold{
  font-size:large;
  margin:20px;
  font-weight: bold;
}
button:hover{
    background-color:var(--highlight-button-color);
    cursor:pointer;
}
button:disabled{
  background-color:gray;
}
.bold{
    font-weight: bold;
}
.left5{
    margin-left:5px;
}
.left10{
    margin-left:10px;
}
.right10{
    margin-right:10px;
}
.bottom10{
    margin-bottom:10px;
}
.messagetext{
    color:black;
    font-size:medium;

}

.titlelabel{
 
    font-size:x-large;
}
textarea{
    font:inherit;
}
.redtext{
  color:var(--color-red);
  font-weight:bold;
}
.orangetext{
  color:var(--color-orange);
  font-weight:bold;
}
.headerclass{
    /* No max-height: the nav tab row wraps (flex-wrap) and must be free to grow to a 2nd/3rd
       line on narrow widths without clipping tabs (e.g. "Filter Attributes" — MJ 2026-07-27).
       Safe because .outerDiv is `grid-template-rows:auto 1fr`, so this header row sizes to its
       content and the tab-content row (1fr) takes the remaining height. A capped height here
       let the wrapped row overflow and be painted over by the content area below. */
}
</style>